import {
  Geo,
  News,
  Documents,
  GeneralNotification
} from '../../assets/images/index';

export const icons = content => {
  switch (content) {
    case 'NEWS':
      return News;
    case 'EVENT':
      return Geo;
    case 'DOCUMENT':
      return Documents;
    default:
      return GeneralNotification;
  }
};
